import React, { useState, useRef, useEffect, useCallback } from 'react';
import { PrimaryButton, SecondaryButton } from '../buttons';
import api, { API_URL } from '../../../api';
import { AlertDiamondIcon } from 'hugeicons-react';
import { showSuccess, showError } from '../../../utils/notificationUtils';

const DeleteMeasure = ({ measureId, synchronousId, isOpen, onClose, removeMeasure, measureName }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [measureDetails, setMeasureDetails] = useState(null);
  const popupRef = useRef(null);

  const fetchMeasureDetails = useCallback(async () => {
    try {
      console.log('Fetching details for measure_id:', measureId);
      const response = await api.get(`${API_URL}/measures/${measureId}/`);
      setMeasureDetails(response.data);
      console.log('Measure details fetched:', response.data);
    } catch (error) {
      console.error('Error fetching measure details:', error);
    }
  }, [measureId]);

  useEffect(() => {
    if (isOpen && measureId) {
      fetchMeasureDetails();
    }
  }, [isOpen, measureId, fetchMeasureDetails]);

  useEffect(() => {
      const handleClickOutside = (e) => {
          if (popupRef.current && !popupRef.current.contains(e.target)) {
              onClose(); 
          }
      };

      document.addEventListener('mousedown', handleClickOutside);
      return () => {
          document.removeEventListener('mousedown', handleClickOutside);
      };
  }, [onClose]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const response = await api.delete(`${API_URL}/measures/delete-measure/${measureId}/`);

      console.log('Delete response:', response);

      if (response.status === 200 || response.status === 204) {
        console.log('Measure deleted successfully, synchronous_id:', synchronousId);
        if (removeMeasure) {
          await removeMeasure(measureId);
        }

        showSuccess(
          `Measure (synchronous_id: ${synchronousId}) deleted successfully!`,
          { duration: 3000 },
          'delete'
        );

        onClose();
      }
    } catch (error) {
      console.error('Error deleting measure:', error.response ? error.response.data : error.message);
      console.error('Failed synchronous_id:', synchronousId);

      const errorMessage = error.response?.data?.message ||
                          error.response?.data?.error ||
                          'An error occurred while deleting the measure.';

      showError(
        `Failed to delete measure (synchronous_id: ${synchronousId}): ${errorMessage}`,
        {},
        'delete'
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="overlay">
      <div className="popup-user" ref={popupRef}>
        <div className="delete-title">
          <AlertDiamondIcon size={68} color='#D0021B'  />
          
        <div className="delete-confirmation">
          <h4 className="title">Delete Measure</h4>
          <p className="paragraph-red">
            Do you really want to delete the measure called <b>{measureName}</b>?
          </p>

          <div className="measure-info">
            {/* <p><strong>ID:</strong> {synchronousId}</p>
            <p><strong>Measure Name:</strong> {measureName}</p> */}
          
           
            {measureDetails && (
              <>
                <p><strong>Name:</strong> {measureDetails.name || 'N/A'}</p>
                <p><strong>Category:</strong> {measureDetails.category_name || measureDetails.category || 'N/A'}</p>
                <p><strong>Group:</strong> {measureDetails.group || 'N/A'}</p>
              </>
            )}
          </div>
  </div>
        </div>

        <div className="buttons">
          <SecondaryButton
            isLoading={false}
            onClick={onClose}
            buttonText={'Cancel'}
            disabled={isSubmitting}
          />
          <PrimaryButton
            isLoading={isSubmitting}
            processingText={`Deleting synchronous_id ${synchronousId}...`}
            buttonText='Delete'
            onClick={handleSubmit}
            disabled={!measureId}
          />
        </div>
      </div>
    </div>
  );
};


export default DeleteMeasure;

